/* eslint-disable */

/** select columns of table "argo.vw_location_hierarchy" */
export enum ArgoVwLocationHierarchySelectColumn {
  /** column name */
  Depth = 'depth',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  ParentName = 'parentName'
}

